// 2023-10-01T09:15:45.500+09:00 のような文字列を返す
// date-fns だけでは無理で、date-fns-tz も必要かつ、それほどコード量も変わらなかったので、ライブラリは使用しない
export const formatDateWithTimezoneOffset = (date: Date): string => {
  const offset = -date.getTimezoneOffset();
  const sign = offset >= 0 ? '+' : '-';
  const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
  const minutes = String(Math.abs(offset) % 60).padStart(2, '0');

  return (
    date
      .toLocaleString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      })
      .replace(/\//g, '-')
      .replace(' ', 'T') +
    `.${String(date.getMilliseconds()).padStart(3, '0')}${sign}${hours}:${minutes}`
  );
};
